
import clickOutside from "./clickOutside.js";
import preventEvent from "./preventEvent.js";
const setupDirective = (app) => {
  app.directive('click-outside', clickOutside);
  app.directive('prevent-event', preventEvent);
}

export default setupDirective